import React from 'react'

export default function ConditionGenComponent() {
  return (
    <div>
      <h1>Condition</h1>
    </div>
  )
}
